import styles from './MovingDateSection.module.css';
import { MovingDateErrors, MovingDateValues } from '@/src/types/MoveOut';
import React, { ChangeEvent, useMemo } from 'react';
import { FormSection } from '../FormSection/FormSection';
import { DatePickerField, Margin } from '@ovotech/element-v5';
import {
  fromDate,
  isMovingDateComplete,
  toDateString,
} from '../../utils/movingDateValuesConversion';
import { addDays, format } from 'date-fns';

type MovingDateSectionProps = {
  values: MovingDateValues;
  errors: MovingDateErrors;
  onValuesChange: (values: MovingDateValues) => void;
};

export const MovingDateSection = ({
  values,
  errors,
  onValuesChange,
}: MovingDateSectionProps) => {
  const value = useMemo(
    () => (isMovingDateComplete(values) ? toDateString(values) : ''),
    [values],
  );

  const { min, max } = useMemo(() => {
    const now = new Date();
    return {
      min: format(addDays(now, -28), 'YYYY-MM-DD'),
      max: format(addDays(now, 27), 'YYYY-MM-DD'),
    };
  }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!value) {
      return;
    }
    const values = fromDate(new Date(value));
    if (values) {
      onValuesChange(values);
    }
  };

  return (
    <FormSection
      id="moving-home-moving-date-section"
      className={styles.formSection}
      title="When's your moving day?"
      description="We'll end your contract on this date, create a final bill and refund any money left on your account."
    >
      <Margin top={[4, 6, 6]}>
        <DatePickerField
          id="moving-home-date"
          label="Moving date"
          value={value}
          error={errors.date}
          min={min}
          max={max}
          fullWidth
          onChange={handleChange}
        />
      </Margin>
    </FormSection>
  );
};
